<template>
  <div :class="['lr-modal', {'hide': !show}]">
    <div class="lr-box">
      <label>Are you sure you want to <b>{{ action }}</b> the selected items?</label>
      <a class="button cta small success block" @click="confirm">
        Confirm
      </a>
      <a class="cta small block" @click="show = false">
        Close
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'alert',
  props: ['action'],
  data () {
    return {
      show: false
    }
  },
  methods: {
    showModal () {
      this.show = true
    },
    confirm () {
      this.show = false
      this.$emit('proceed')
    }
  },
}
</script>

<style lang="scss" scoped>
.lr-modal {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999;
  width: 100%;
  height: 100%;
  background-color: rgba(0,0,0,0.35);
  overflow: auto;
  opacity: 1;
  display: flex;
  justify-content: center!important;
  align-items: center!important;
  -webkit-transition: all 0.2s ease-in;
  -moz-transition: all 0.2s ease-in;
  -o-transition: all 0.2s ease-in;
  transition: all 0.2s ease-in;

  &.hide {
    top: -100%;
    opacity: 0;
  }
}
.lr-box {
  background: #fff;
  padding: 20px;
  border-radius: 6px;
  box-shadow: 3px 3px 2px rgba(0,0,0, .3);
  text-align: center;
  width: 300px;
}

label{
  margin-bottom: 20px;
  display: block;
}

.button{
  margin-bottom: 10px;
}
.cta{
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/Airtag/confirm.vue